import { render, staticRenderFns } from "./ModalInformacao.vue?vue&type=template&id=e9946544&scoped=true"
import script from "./ModalInformacao.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalInformacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalInformacao.vue?vue&type=style&index=0&id=e9946544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9946544",
  null
  
)

export default component.exports